import { render, staticRenderFns } from "./PaymentResponse.vue?vue&type=template&id=2f40a502&"
import script from "./PaymentResponse.vue?vue&type=script&lang=js&"
export * from "./PaymentResponse.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResponse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports